import * as utils from 'Utils';


export function postRecommenderTrackClick(successCallback, errorCallback, data) {
  utils.postRq({
    "url": utils.buildUrl(`recommenders/track-click`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postRecommenderTrackRecentlyViewed(successCallback, errorCallback, data) {
  utils.postRq({
    "url": utils.buildUrl(`recommenders/track-recently-viewed`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

